import { IMG_URL } from "configs";

export default function Video({ src, autoPlay, loop, muted = true, playsInline = true, ...props }) {
  return (
    <video
      src={`${IMG_URL}/${src}`}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      playsInline={playsInline}
      {...props}
    />
  );
}
